import React from "react";
import { Row, Col, Card, Button } from "reactstrap";
import { connect } from "react-redux";
import Dotdotdot from "react-dotdotdot";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import {
  serviceCaller,
  withModals,
  withLoginRedirect,
} from "../../composition";
import * as modalActions from "../../../utils/actions/modals";
import { getParsedDate } from "../../../utils/helpers";
import IRequest from "../../../types/services/IRequest";
import IUser from "../../../types/services/IUser";

interface Props {
  request: IRequest;
  index;
  user: IUser;
  toggleRequestDetailModal: (request: IRequest) => void;
}

interface State {
  loading: boolean;
}

class RequestItem extends React.PureComponent<Props, State> {
  state = {
    loading: false,
  };

  detail() {
    this.props.toggleRequestDetailModal(this.props.request);
  }

  delete() {}

  getRecipientList() {
    return this.props.request.recipientsInfo.map((user, index) => (
      <span key={index}>
        {user.name +
          (index !== this.props.request.recipientsInfo.length - 1 ? ", " : "")}
      </span>
    ));
  }

  render() {
    const { request, index, user } = this.props;
    return (
      <Card
        className={s.card}
        data-elm-id={`post_list_row_postId_${request.id}`}
        key={index}
      >
        <Row>
          <Col xs={12} md={7}>
            <div className={s.content}>
              <h6> {"Author: " + user.name}</h6>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <p className={s.date}>
              {"Created: " +
                (request.createdOn
                  ? getParsedDate(
                      new Date(request.createdOn).toString(),
                      false,
                      "MM/DD/YYYY, hh:mm a"
                    )
                  : "Not available")}
            </p>
          </Col>
          <Col xs={6} md={2}>
            <div className={s.buttonContainer}>
              <Button className={s.button} onClick={() => this.detail()}>
                Detail
              </Button>
            </div>
          </Col>
        </Row>
        {this.props.request.recipientsInfo &&
        this.props.request.recipientsInfo.length > 0 ? (
          <Row>
            <Col xs={12}>
              <h6>Recipients: {this.getRecipientList()}</h6>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Row>
          <Col xs={12}>
            <div className={s.content}>
              <Dotdotdot clamp={2}>
                <p>{request.message || "..."}</p>
              </Dotdotdot>
            </div>
          </Col>
        </Row>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  toggleRequestDetailModal: (request: IRequest) => {
    dispatch(modalActions.toggleRequestDetailModal(request));
  },
});

export default connect<Props>(
  null,
  mapDispatchToProps
)(serviceCaller(withLoginRedirect(withModals(withStyles(s)(RequestItem)))));
